import React from 'react';
import { Warning } from '../../modules/Icons';
import { LicenseWarningTagProps } from '../../types/components/products/LicenseWarningTag';


const LicenseWarningTag: React.FC<LicenseWarningTagProps> = ({ className, productId = '' }) => {
  return (
    <div className={className}>
      <div data-tooltip-id={'license-warning-' + productId.toString()}>
        <Warning />
      </div>
    </div>
  )
}

export default LicenseWarningTag;